/* eslint-disable prettier/prettier */
import { CONSTANTS, palette } from '@livable/saas-react-components';
import breakpointsFunc from '../breakpointsFunc';
const MuiAppBar = {
  styleOverrides: {
    root: {
      boxShadow: 'none',
      backgroundColor: "".concat(palette.shades[200]),
      padding: '0 24px 0 8px',
      color: palette.shades[800],
      height: "".concat(CONSTANTS.NEW_HEADER_HEIGHT + 'px'),
      [breakpointsFunc.breakpoints.down('md')]: {
        padding: '0 10px'
      },
      '.MuiToolbar-root': {
        padding: '0',
        height: '100%',
        minHeight: 'initial',
        justifyContent: 'space-between'
      },
      '.logo': {
        display: 'inline-block',
        margin: '14px 0'
      },
      '.search-bar': {
        marginLeft: '20px',
        flexGrow: '1',
        position: 'relative'
      },
      '.header-buttons': {
        display: 'flex',
        alignItems: 'center'
      }
    }
  }
};
export default MuiAppBar;